import { isArray } from 'util';
import Notifications from './notifications';

const withErrorNotification = async (handler, failureHandler) => {
    try {
        return await handler();
    } catch (e) {
        
        console.log(e);
        
        const { response } = e;
        
        if( ! response ) {
            console.log(e.status);
            Notifications.showNotification('Error occured', e.message.replace(/Error: /i, ""), 'danger');
            return failureHandler ? await failureHandler() : null;
        } else {
            const { data } = response;
            const { error } = data;

            console.log(error);
            console.log(typeof(error));
    
            if (error && typeof(error) == 'string') {
                Notifications.showNotification('Error occured', error, 'danger');
            } else if (isArray(error)) {
                const [firstError] = error;
                console.log(firstError); 
                Notifications.showNotification('Error occured', firstError.msg, 'danger');
            } else {
                console.log(error);
                Notifications.showNotification('Error occured', 'error', 'danger');
            }
        }

        return failureHandler ? await failureHandler() : null;
        
    }
}

export { withErrorNotification };

export default withErrorNotification;